import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import * as globalConstant from './../global_constant';

@Injectable({
    providedIn: 'root'
})
export class InfluencerService {
    apiDomain = globalConstant.DOMAIN;
    siteRequestFrom = globalConstant.SITE_REQUEST_FROM;
    listApi = globalConstant.GET_INFLUENCERS_LIST;
    followApi = globalConstant.FOLLOW_UNFOLLOW_INFLUENCER;
    getInfluencerData = globalConstant.GET_INFLUENCER_DETAILS;
    getTripsList = globalConstant.GET_INFLUENCER_TRIP_LIST;
    createTripData = globalConstant.GET_INFLUENCER_CREATE_TRIP;
    deleteTripData = globalConstant.GET_INFLUENCER_DELETE_TRIP;
	updateInfluencer = globalConstant.UPDATE_INFLUENCER_DATA;
	addExpReview = globalConstant.ADD_REVIEW;
	agreeTermsAndConditions = globalConstant.AGREE_INFLUENCER_TERMS;
	getFollowers = globalConstant.GET_FOLLOWERS;
	uploadContent = globalConstant.UPLOAD_CONTENT;
	getExpiredTrips = globalConstant.GET_EXPIRED_TRIPS;
	uploadSocialMediaUrl = globalConstant.UPLOAD_POST_URL;

    constructor(public router: Router, private http: HttpClient) { }

    inflencerListData(formData, headers) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
                'requestFrom':this.siteRequestFrom    
            })
        };
        return this.http.post<any>(this.apiDomain + this.listApi, formData, httpOptions).pipe(map(res => {
            return res;
        }),
            catchError(err => {
                return err.error;
            }));
    }

	getFollowersListData(formData, headers) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
                'requestFrom':this.siteRequestFrom    
            })
        };
        return this.http.post<any>(this.apiDomain + this.getFollowers, formData, httpOptions).pipe(map(res => {
            return res;
        }),
            catchError(err => {
                return err.error;
            }));
    }

	inflencerAgreeTermsAndConditions(formData, headers) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
                'requestFrom':this.siteRequestFrom    
            })
        };
        return this.http.post<any>(this.apiDomain + this.agreeTermsAndConditions, formData, httpOptions).pipe(map(res => {
            return res;
        }),
            catchError(err => {
                return err.error;
            }));
    }

    followUnfollowInfluencer(headers, data){
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
				'requestFrom':this.siteRequestFrom
			})
		};
		return this.http.post<any>(this.apiDomain+this.followApi, data,httpOptions).pipe(map(res=>{
			return res;
		}),
		catchError(err => {
			return err.error;
		}));
	}

    getInfluencerDetails(headers, data){
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
				'requestFrom':this.siteRequestFrom
			})
		};
		return this.http.post<any>(this.apiDomain+this.getInfluencerData, data,httpOptions).pipe(map(res=>{
			return res;
		}),
		catchError(err => {
			return err.error;
		}));
	}

    getInfluencerTripsList(headers){
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization':'Bearer '+headers,
			'requestFrom':this.siteRequestFrom
          })
        };
        return this.http.get<any>(this.apiDomain+this.getTripsList,httpOptions).pipe(map(res=>{
          return res;
        }),
        catchError(err => {
          return err.error;
        }));
    } 
    
    createNewTrip(headers, data){
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
				'requestFrom':this.siteRequestFrom
			})
		};
		return this.http.post<any>(this.apiDomain+this.createTripData, data,httpOptions).pipe(map(res=>{
			return res;
		}),
		catchError(err => {
			return err.error;
		}));
	}

    deleteTrip(headers, data){
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
				'requestFrom':this.siteRequestFrom
			})
		};
		return this.http.post<any>(this.apiDomain+this.deleteTripData, data,httpOptions).pipe(map(res=>{
			return res;
		}),
		catchError(err => {
			return err.error;
		}));
	}

	updateInfluencerData(headers, data){
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
				'requestFrom':this.siteRequestFrom
			})
		};
		return this.http.post<any>(this.apiDomain+this.updateInfluencer, data,httpOptions).pipe(map(res=>{
			return res;
		}),
		catchError(err => {
			return err.error;
		}));
	}

	addReview(headers, data){
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
				'requestFrom':this.siteRequestFrom
			})
		};
		return this.http.post<any>(this.apiDomain+this.addExpReview, data,httpOptions).pipe(map(res=>{
			return res;
		}),
		catchError(err => {
			return err.error;
		}));
	}

	uploadContentInfluencer(headers, data){
		const httpOptions = {
			headers: new HttpHeaders({
                'Authorization':'Bearer '+headers,
				'requestFrom':this.siteRequestFrom
			})
		};
		return this.http.post<any>(this.apiDomain+this.uploadContent, data,httpOptions).pipe(map(res=>{
			return res;
		}),
		catchError(err => {
			return err.error;
		}));
	}

	uploadPostUrl(headers, data){
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
				'requestFrom':this.siteRequestFrom
			})
		};
		return this.http.post<any>(this.apiDomain+this.uploadSocialMediaUrl, data,httpOptions).pipe(map(res=>{
			return res;
		}),
		catchError(err => {
			return err.error;
		}));
	}

	getExpiredInfluencerTrips(headers, data){
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
                'Authorization':'Bearer '+headers,
				'requestFrom':this.siteRequestFrom
			})
		};
		return this.http.post<any>(this.apiDomain+this.getExpiredTrips, data,httpOptions).pipe(map(res=>{
			return res;
		}),
		catchError(err => {
			return err.error;
		}));
	}

}




